import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

const initialShaktis = [
  { name: 'Priya Sharma', place: 'Surat', score: 94 },
  { name: 'Anjali Patel', place: 'Pune', score: 92 },
  { name: 'Sneha Gupta', place: 'Nagpur', score: 90 },
  { name: 'Pooja Singh', place: 'Chandigarh', score: 89 },
  { name: 'Riya Reddy', place: 'Hyderabad', score: 87 },
  { name: 'Neha Kumar', place: 'Coimbatore', score: 86 },
  { name: 'Divya Joshi', place: 'Rajkot', score: 85 },
  { name: 'Meera Desai', place: 'Indore', score: 84 },
  { name: 'Kavya Rao', place: 'Bengaluru', score: 83 },
  { name: 'Sita Nair', place: 'Vadodara', score: 82 },
  { name: 'Lata Iyer', place: 'Aurangabad', score: 91 },
  { name: 'Geeta Yadav', place: 'Jaipur', score: 88 },
  { name: 'Rina Das', place: 'Jamshedpur', score: 85 },
  { name: 'Tara Bose', place: 'Bhopal', score: 83 },
  { name: 'Uma Mishra', place: 'Lucknow', score: 80 }
];

const SakshamShaktiScorecard = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [rankings, setRankings] = useState([]);

  const shuffleAndSelectTop10 = () => {
    const shuffled = [...initialShaktis]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((item, index) => ({ rank: index + 1, ...item }));
    setRankings(shuffled);
  };

  useEffect(() => {
    shuffleAndSelectTop10();
    const interval = setInterval(shuffleAndSelectTop10, 5000);
    return () => clearInterval(interval);
  }, []);

  const today = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  });

  return (
    <div className="flex flex-col min-h-screen text-white bg-black">
      <header className="flex justify-between items-center px-4 py-0 bg-black text-white border-b border-pink-300 shadow-lg sticky top-0 z-50">
        <div
          onClick={() => navigate('/rankings')}
          className="text-lg font-bold text-white cursor-pointer sm:text-xl"
        >
          💖 SAKSHAM Shakti Rankings
        </div>
        <div className="hidden md:flex items-center space-x-2">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 mt-2 flex items-center justify-center text-lg bg-blue-500 text-white rounded-full hover:bg-blue-600 transition sm:w-9 sm:h-9"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden mt-2 w-8 h-8 flex items-center justify-center text-xl bg-blue-700 text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>        
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-blue-700 flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-blue-500 text-white">
              <p className="mb-2 text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-blue-500 text-white mt-4 px-4 py-2 rounded text-sm hover:bg-blue-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <main className="flex-1 p-4 flex flex-col">
        <div className="text-center mb-2 shrink-0">
          <p className="text-yellow-200 text-sm lg:text-m">{today}</p>
        </div>

        <div className="flex-1 overflow-x-auto bg-black shadow-lg rounded-lg border border-gray-700">
          <table className="w-full h-full table-fixed">
            <colgroup>
              <col className="w-12" />
              <col className="w-1/3 min-w-[120px]" />
              <col className="w-1/4 min-w-[80px]" />
              <col className="w-16" />
            </colgroup>
            <thead className="bg-black sticky top-0">
              <tr>
                <th className="py-1 px-1 text-left text-xs lg:text-m font-semibold text-pink-200 border-b border-gray-600 truncate">Rank</th>
                <th className="py-1 px-1 text-left text-xs lg:text-m font-semibold text-pink-200 border-b border-gray-600 truncate sm:px-2">Shakti Name</th>
                <th className="py-1 px-1 text-left text-xs lg:text-m font-semibold text-pink-200 border-b border-gray-600 truncate sm:px-2">Place</th>
                <th className="py-1 px-1 text-left text-xs lg:text-m font-semibold text-pink-200 border-b border-gray-600 truncate sm:px-2">Score</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {rankings.map(({ rank, name, place, score }) => (
                <tr key={name} className="hover:bg-gray-700 transition-colors duration-200">
                  <td className="py-1 px-1 text-xs lg:text-m font-medium text-white border-r border-gray-600 truncate">{rank}</td>
                  <td className="py-1 px-1 text-xs lg:text-m text-gray-300 border-r border-gray-600 truncate sm:px-2">{name}</td>
                  <td className="py-1 px-1 text-xs lg:text-m text-gray-300 border-r border-gray-600 truncate sm:px-2">{place}</td>
                  <td className="py-1 px-1 text-xs lg:text-m font-bold text-pink-300 truncate sm:px-2">{score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      <footer className="bg-black border-t border-pink-300 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-200 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SakshamShaktiScorecard;
